import axios from "axios";

(function() {
    const element = <HTMLElement>document.querySelector('[data-amadeus-page]');
    if (element) {
        axios.get('/api/user')
            .then(res => {
                element.querySelector('[data-agency-name]').innerHTML = res.data.currentAgency.name
                element.querySelector('[data-agency-number]').innerHTML = res.data.currentAgency.number
                element.querySelector('[data-agent-name]').innerHTML = res.data.user.fullName
                element.querySelector('[data-amadeus-page-account]').setAttribute('style', 'display:block')
            })
            .catch(res => {
                console.warn('Could not get user data.')
            })
    }
}());
